import { useRef } from 'react';

export const isEqual = (first: unknown[], second: unknown[]): boolean =>
    first === second || (first.length === second.length && first.every((e: unknown, i: number) => e === second[i]));

/**
 * Хук для мемоизации массивов с поэлементным сравнением
 */
const useArrayMemo = <T>(array: T[]): T[] => {
    const ref = useRef(array);

    if (!isEqual(ref.current, array)) {
        ref.current = array;
    }

    return ref.current;
};

export { useArrayMemo };
